"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceholderIconPrivalia = exports.PlaceholderIcon = exports.ImagePlaceholder = exports.LoaderContainer = exports.Image = void 0;
const Placeholder_1 = __importDefault(require("@kawaui/icons/build/icons/informative/Placeholder"));
const PlaceholderPrivalia_1 = __importDefault(require("@kawaui/icons/build/icons/informative/PlaceholderPrivalia"));
const styled_components_1 = __importStar(require("styled-components"));
exports.Image = styled_components_1.default.img `
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;

  display: ${({ isHidden }) => (isHidden ? 'none' : 'inline-block')};
`;
exports.LoaderContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;

  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '100%'};
`;
exports.ImagePlaceholder = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;

  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '100%'};

  background-color: ${({ theme }) => theme.colors.gray.s200};
`;
const iconHelper = (0, styled_components_1.css) `
  height: 35%;
  width: 35%;
  path {
    fill: ${({ theme }) => theme.colors.gray.s300};
  }
`;
exports.PlaceholderIcon = (0, styled_components_1.default)(Placeholder_1.default) `
  ${iconHelper};
`;
exports.PlaceholderIconPrivalia = (0, styled_components_1.default)(PlaceholderPrivalia_1.default) `
  ${iconHelper};
`;
